import React, { ReactNode } from 'react';
import { Translate } from 'react-redux-i18n';
import PersonalInformationForm from './PersonalInformationForm';
import camera from '../../../../../img/icones/camera2.svg';
import { MonIdentite } from '../../../../../network/api/types/compte/MonIdentite';
import PicturePopin from '../../../../external/PicturePopin';
import cartoucheHomme from '../../../../../img/cartouche_homme.png';
import cartoucheFemme from '../../../../../img/cartouche_femme.png';

type Props = {
  onClose: () => void
  myIdentity?: MonIdentite
  setDirty?: (dirty: boolean, callback?: () => void) => void
  setModalI18n?: (title: string, subtitle: string) => void
};

type State = {
  openImagePopin: boolean,
};

class PersonalInformation extends React.Component<Props, State> {
  state: State = {
    openImagePopin: false,
  };

  toogleImagePopin = (): void =>
    this.setState((previousState) => ({ openImagePopin: !previousState.openImagePopin }));

  getAvatar = (): string => {
    const cartouche = this.props.myIdentity?.civilite.toUpperCase() === 'MONSIEUR' ? cartoucheHomme : cartoucheFemme;
    return this.props.myIdentity?.photo || cartouche;
  };

  render(): ReactNode {
    const image = this.getAvatar();
    return (
      <div className="personal-drawer">
        {
          this.props.myIdentity
          && (
            <PicturePopin
              isOpen={this.state.openImagePopin}
              onClose={this.toogleImagePopin}
              image={image}
              myIdentity={this.props.myIdentity}
            />
          )
        }

        <div className="drawer-title">
          <h3>
            <Translate value="PERSONAL_INFORMATION.PERSONAL_INFORMATION" />
          </h3>
          <div className="subtitle">
            <Translate value="PERSONAL_INFORMATION.UNIQUENESS" />
          </div>
          <div className="additional-subtitle">
            <Translate value="PERSONAL_INFORMATION.PRIVATE_INFO" />
          </div>
        </div>
        <div className="drawer-divider-horizontal" />
        <div className="personal-content">
          <div className="photo-row">
            <div className="container-img smol">
              <img
                className="profile-pic"
                src={image}
                alt="foto"
              />
              <button
                type="button"
                onClick={this.toogleImagePopin}
              >
                <label htmlFor="add-photo" className="add-photo-label">
                  <img
                    className="add-foto"
                    src={camera}
                    alt="add-foto"
                  />
                </label>
              </button>
            </div>
            <div>
              {this.props.myIdentity?.prenom}
              <br />
              {this.props.myIdentity?.nomUsuel}
            </div>
          </div>
          <PersonalInformationForm
            onClose={this.props.onClose}
            myIdentity={this.props.myIdentity}
            setDirty={this.props.setDirty}
            setModalI18n={this.props.setModalI18n}
          />
        </div>
      </div>
    );
  }
}

export default PersonalInformation;
